/* @preserveSideEffects */
// Theme toggle logic
(function () {
  const STORAGE_KEY = 'portalTheme';
  const root = document.documentElement;
  const toggleBtn = document.getElementById('theme-toggle');
  const mobileToggle = document.getElementById('mobile-theme-toggle');
  const mobileIcon = document.getElementById('mobile-theme-icon');
  const mobileLabel = document.getElementById('mobile-theme-label');
  function apply(theme) {
    const isDark = theme === 'dark';
    if (isDark) {
      root.setAttribute('data-theme', 'dark');
      toggleBtn?.setAttribute('aria-pressed', 'true');
      const label = toggleBtn?.querySelector('.theme-toggle__label');
      if (label) label.textContent = 'Dark';
    } else {
      root.removeAttribute('data-theme');
      toggleBtn?.setAttribute('aria-pressed', 'false');
      const label = toggleBtn?.querySelector('.theme-toggle__label');
      if (label) label.textContent = 'Light';
    }
    if (mobileIcon)
      mobileIcon.textContent = isDark
        ? String.fromCodePoint(0x1f31e)
        : String.fromCodePoint(0x1f319);
    if (mobileLabel) mobileLabel.textContent = isDark ? 'Light mode' : 'Dark mode';
  }
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  let saved = localStorage.getItem(STORAGE_KEY);
  if (!saved) {
    saved = media.matches ? 'dark' : 'light';
  }
  apply(saved);
  media.addEventListener('change', e => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      apply(e.matches ? 'dark' : 'light');
    }
  });
  const toggle = () => {
    const current = root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    const next = current === 'dark' ? 'light' : 'dark';
    localStorage.setItem(STORAGE_KEY, next);
    apply(next);
  };
  if (toggleBtn) {
    toggleBtn.addEventListener('click', toggle);
  }
  if (mobileToggle) {
    mobileToggle.addEventListener('click', toggle);
  }
})();
